module.exports = __webpack_public_path__ + "static/img/user_story_avatar2.1da98daa.png";